import styled from 'styled-components';

const Container = styled.div`
  margin: 10px;
  cursor: pointer;

  :hover {
    color: white;
  }
`;

export default Container;
